import { createContext, useRef, useState } from "react";



const QuestionsNavContext = createContext<{slidesRef: any}>({
  slidesRef:  null
})

export default QuestionsNavContext
